// extracted by mini-css-extract-plugin
module.exports = {"overviewWrapper":"Overview_overviewWrapper__hL2__","handoverHint":"Overview_handoverHint__25Irb"};